export default __webpack_public_path__ + "static/media/linkedin.c87f79df.svg";